import { render } from "./TheHeader.vue?vue&type=template&id=3963a88f&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=3963a88f&scoped=true&lang=css"

import exportComponent from "/Users/jj_mac/Documents/find-a-mentor-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3963a88f"]])

export default __exports__